import { Box, Chip, Stack, TextField, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import MDButton from "theme/components/MDButton";
import AggregationBlock from "./aggregation_block";

const OPS = ["+", "-", "*", "/"];

export default function ExpressionComposer({ fields, onComplete }) {
  const [parts, setParts] = useState([]);

  const [preview, setPreview] = useState("");

  const buildAggString = (agg) => {
    let expr = `${agg.func}(${agg.field}`;

    if (agg.filters.length) {
      let cond = agg.filters.map((f) => `${f.field}${f.op}'${f.value}'`).join(" AND ");

      expr += ` WHERE ${cond}`;
    }

    expr += ")";
    return expr;
  };

  const canAddAggregation = () => {
    if (parts.length === 0) return true;
    const last = parts[parts.length - 1];
    return last.type === "op";
  };

  useEffect(() => {
    let expr = parts
      .map((p) => {
        if (p.type === "agg") return buildAggString(p);

        return p.value;
      })
      .join(" ");

    setPreview(expr);
  }, [parts]);

  return (
    <Box mt={2}>
      <Box direction="row" display="flex" justifyContent="space-evenly">
        <MDButton
          variant="outlined"
          color="dark"
          size="small"
          onClick={() => {
            if (!canAddAggregation()) return;
            setParts([
              ...parts,
              {
                type: "agg",
                func: "",
                field: "",
                filters: [],
              },
            ]);
          }}
        >
          FUNCTION
        </MDButton>

        <MDButton
          onClick={() =>
            setParts([
              ...parts,
              {
                type: "literal",
                value: "",
              },
            ])
          }
          variant="outlined"
          color="dark"
          size="small"
        >
          Value
        </MDButton>

        {OPS.map((op) => (
          <MDButton
            key={op}
            onClick={() =>
              setParts([
                ...parts,
                {
                  type: "op",
                  value: op,
                },
              ])
            }
            variant="outlined"
            color="dark"
            size="small"
          >
            {op}
          </MDButton>
        ))}

        <MDButton
          onClick={() =>
            setParts([
              ...parts,
              {
                type: "paren",
                value: "(",
              },
            ])
          }
          variant="outlined"
          color="dark"
          size="small"
        >
          (
        </MDButton>

        <MDButton
          variant="outlined"
          onClick={() =>
            setParts([
              ...parts,
              {
                type: "paren",
                value: ")",
              },
            ])
          }
          color="dark"
          size="small"
        >
          )
        </MDButton>

        <MDButton
          variant="outlined"
          onClick={() => setParts(parts.slice(0, -1))}
          color="dark"
          size="small"
        >
          Undo
        </MDButton>
      </Box>

      <Box mt={5}>
        <Box mt={2} spacing={1}>
          {parts.map((p, i) => {
            if (p.type === "agg") {
              return (
                <Box border={0.3} mt={2} px={1}>
                  <AggregationBlock
                    key={i}
                    data={p}
                    fields={fields}
                    onChange={(np) => {
                      let copy = [...parts];
                      copy[i] = np;
                      setParts(copy);
                    }}
                    onRemove={() => {
                      let copy = [...parts];
                      copy.splice(i, 1);
                      setParts(copy);
                    }}
                  />
                </Box>
              );
            }

            if (p.type === "literal") {
              return (
                <Box mt={2} p={1}>
                  <TextField
                    fullWidth
                    key={i}
                    label="Value"
                    value={p.value}
                    onChange={(e) => {
                      let copy = [...parts];

                      copy[i] = {
                        ...p,
                        value: e.target.value,
                      };

                      setParts(copy);
                    }}
                  />
                </Box>
              );
            }

            return (
              <Box align="center" my={1} px={1}>
                <Chip key={i} label={p.value} />
              </Box>
            );
          })}
        </Box>
      </Box>

      {preview && (
        <Box align="center">
          <Box mt={5}>
            <Typography fontSize={14}>Preview Expression</Typography>
            <TextField multiline fullWidth value={preview} readOnly />
          </Box>
          <Box align="center">
            <MDButton
              variant="contained"
              sx={{ mt: 2 }}
              onClick={() => onComplete(preview)}
              color="dark"
              size="small"
            >
              Save Expression
            </MDButton>
          </Box>
        </Box>
      )}
    </Box>
  );
}
